import React, { FC, forwardRef, ReactNode } from 'react';
import clsx from 'clsx';
import CheckIcon from '@material-ui/icons/Check';
import useStyles from './style';
import MenuItem, { MenuItemProps } from '@material-ui/core/MenuItem';

export interface MenuOptionProps extends MenuItemProps {
    icon?: ReactNode;
    button?: true;
}

const MenuOption: FC<MenuOptionProps> = forwardRef((props: MenuOptionProps, ref) => {
    const { className, icon, children, ...other } = props;
    const classes = useStyles();
    const classNameMerged = clsx({ [classes.checkedIcon]: icon, className });

    return (
        <MenuItem ref={ref} className={classNameMerged} {...other}>
            {children}
            {icon}
        </MenuItem>
    );
});

MenuOption.defaultProps = {
    icon: <CheckIcon fontSize="small" />,
};

MenuOption.displayName = 'MenuOption';

export default MenuOption;
